module.exports = __webpack_public_path__ + "static/media/man.17a749b7.jpg";